import {put} from 'redux-saga/effects';

import {enqueueSnackbar} from '@troy/shared/src/store/actions';

import {logout, setError} from '../actions';

export function* handleError({payload: err}) {
  yield put(setError(err));
  const silentErrors = ["Refresh Token has been revoked", "Unauthorized"];
  const logoutErrors = ["Invalid refresh token", "You must provide a valid Authorization header"]
  if(logoutErrors.includes(err.message)) {
    yield put(logout());
    return;
  }
  if (!silentErrors.includes(err.message)) {
    yield put(
      enqueueSnackbar({
        message: err.message,
        options: {
          variant: 'error',
        }
      })
    );
  }
}
